import { PricesMap } from '@bitly/sdk/dist/types'
import { createSlice } from '@reduxjs/toolkit'

import { DEFAULT_QUERY_STATUS, LOADING_STATUS, SUCCESS_STATUS } from 'state/constants'
import { FetchStatus } from 'state/types'

import { fetchPreviousDayPrices, fetchPricesSeries, fetchOraclePrices } from './actions'
import { PricesState } from './types'
import { AppThunk } from 'state/store'

export const PRICES_INITIAL_STATE: PricesState = {
	onChainPrices: {},
	oraclePrices: {},
	connectionError: null,
	previousDayPrices: {},
	pricesSeries: {},
	queryStatuses: {
		previousDayPrices: DEFAULT_QUERY_STATUS,
		pricesSeries: DEFAULT_QUERY_STATUS,
	},
}

const pricesSlice = createSlice({
	name: 'prices',
	initialState: PRICES_INITIAL_STATE,
	reducers: {
		setOnChainPrices: (state, action) => {
			state.onChainPrices = action.payload
		},
	},
	extraReducers: (builder) => {
		// Fetch past daily prices
		builder.addCase(fetchPreviousDayPrices.pending, (pricesState) => {
			pricesState.queryStatuses.previousDayPrices = LOADING_STATUS
		})
		builder.addCase(fetchPreviousDayPrices.fulfilled, (pricesState, action) => {
			const prices: PricesMap = {}
			Object.entries(action.payload).forEach(([key, price]) => {
				prices[key] = price
			})
			pricesState.previousDayPrices = prices
			pricesState.queryStatuses.previousDayPrices = SUCCESS_STATUS
		})
		builder.addCase(fetchPreviousDayPrices.rejected, (pricesState) => {
			pricesState.queryStatuses.previousDayPrices = {
				error: 'Failed to fetch past prices',
				status: FetchStatus.Error,
			}
		})

		// Fetch prices series
		builder.addCase(fetchPricesSeries.pending, (pricesState) => {
			pricesState.queryStatuses.pricesSeries = LOADING_STATUS
		})
		builder.addCase(fetchPricesSeries.fulfilled, (pricesState, action) => {
			pricesState.pricesSeries = action.payload
			pricesState.queryStatuses.pricesSeries = SUCCESS_STATUS
		})
		builder.addCase(fetchPricesSeries.rejected, (pricesState) => {
			pricesState.queryStatuses.pricesSeries = {
				error: 'Failed to fetch past prices series',
				status: FetchStatus.Error,
			}
		})

		// Fetch oracle prices
		builder.addCase(fetchOraclePrices.fulfilled, (pricesState, action) => {
			pricesState.oraclePrices = action.payload
		})
	},
})

export const { setOnChainPrices } = pricesSlice.actions

export const updatePrices =
	(newPrices: PricesMap): AppThunk =>
	(dispatch, getState) => {
		dispatch(setOnChainPrices(newPrices))
	}

export default pricesSlice.reducer
